import { render, staticRenderFns } from "./skillCourse_edit.vue?vue&type=template&id=518dd63e&scoped=true"
import script from "./skillCourse_edit.vue?vue&type=script&lang=js"
export * from "./skillCourse_edit.vue?vue&type=script&lang=js"
import style0 from "./skillCourse_edit.vue?vue&type=style&index=0&id=518dd63e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518dd63e",
  null
  
)

export default component.exports